import React, { useState } from "react"
import { CheckboxSetting, Section } from "./Shared"
import { useSelector } from "react-redux"
import { useFormContext } from "react-hook-form"
import L10n from "../../../lib/carrot-l10n"
import { getEmailOptIn } from "../../../reducers/userInfo"
import { FormCheckbox } from "../atoms/Checkbox"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const CommunicationSettings = () => {
  const { errors, register } = useFormContext()
  const currentEmailOptIn = useSelector(getEmailOptIn)
  const [emailOptIn, setEmailOptIn] = useState(currentEmailOptIn)

  const emailOptInSetting = (
    <FormCheckbox
      name={"emailOptIn"}
      label={l`client.accountSettings.emailOptIn`}
      checked={emailOptIn}
      onChange={(e) => setEmailOptIn(e.target.checked)}
      errors={errors}
      ref={register}
    />
  )

  return (
    <Section title="Communication settings" description="">
      <label>
        <CheckboxSetting
          title="Subscribe to marketing emails"
          description="This includes recommendations, promotions, tips, and new feature announcements."
        >
          {emailOptInSetting}
        </CheckboxSetting>
      </label>
    </Section>
  )
}

export { CommunicationSettings }
